import { GivelifyLabel } from '@givelify/ui';
import { ActionRow, Link } from './style';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

type FooterProps = {
    onResend: () => void;
    onSupport: () => void;
};

export const Footer: React.FC<FooterProps> = ({ onResend, onSupport }) => {
    const { t } = useTranslation();
    const copy = useMemo(
        () => ({
            didntReceive: t('signup.submitted.didntReceive'),
            incorrectEmail: t('signup.submitted.incorrectEmail'),
            resend: t('signup.submitted.resend'),
            contact: t('signup.submitted.contact'),
        }),
        [t],
    );
    return (
        <>
            <ActionRow>
                <GivelifyLabel className="text" text={copy.didntReceive} />
                <Link className="text" text={copy.resend} onClick={onResend} />
            </ActionRow>
            <ActionRow column>
                <GivelifyLabel className="text" text={copy.incorrectEmail} />
                <Link
                    className="text"
                    text={copy.contact}
                    onClick={onSupport}
                />
            </ActionRow>
        </>
    );
};
